type SanitizedObject<T> = {
  [K in keyof T as T[K] extends undefined ? never : K]: T[K];
};

export const getSanitizedObject = <T extends Record<string, unknown>>(
  obj: T,
): SanitizedObject<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined),
  ) as SanitizedObject<T>;
